export const SHOP_TITLES = Object.freeze([
    { id: 'shop-founder', title: 'Fondateur', offer: 'founder-pack' },
    { id: 'shop-dragon', title: 'Cœur de Dragon', offer: 'dragon-pack' },
    { id: 'shop-scarecrow', title: 'L’Épouvantail qui marche', offer: 'scarecrow-pack' },
    { id: 'shop-aurora', title: 'Veilleur de l’Aurore', offer: 'aurora-pack' },
    { id: 'shop-dragonslayer', title: 'Tueur de Wyrm', offer: 'dragonslayer-pack' },
    { id: 'shop-sylvan', title: 'Esprit de la Forêt', offer: 'sylvan-pack' },
    { id: 'shop-bogwitch', title: 'Maître des Tourbières', offer: 'bogwitch-pack' },
    { id: 'shop-djinn', title: 'Seigneur des Mirages', offer: 'djinn-pack' },
    { id: 'shop-shaman', title: 'Voix des Esprits', offer: 'shaman-pack' },
]);
const BY_ID = new Map(SHOP_TITLES.map((t) => [t.id, t]));
export function getShopTitle(id) {
    return BY_ID.get(id);
}
/** The title an offer comes with, for the shop to say so. */
export function shopTitleOfOffer(offerId) {
    return SHOP_TITLES.find((title) => title.offer === offerId);
}
/** The shop titles an account's kept offers give, in the order of the data. */
export function shopTitlesOf(purchases) {
    return SHOP_TITLES.filter((title) => purchases.includes(title.offer)).map((title) => title.id);
}
//# sourceMappingURL=shop-titles.js.map